var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8333 7.33341V5.50008C12.8333 5.01385 12.6402 4.54754 12.2964 4.20372C11.9525 3.8599 11.4862 3.66675 11 3.66675H4.58333C4.0971 3.66675 3.63079 3.8599 3.28697 4.20372C2.94315 4.54754 2.75 5.01385 2.75 5.50008V16.5001C2.75 16.9863 2.94315 17.4526 3.28697 17.7964C3.63079 18.1403 4.0971 18.3334 4.58333 18.3334H11C11.4862 18.3334 11.9525 18.1403 12.2964 17.7964C12.6402 17.4526 12.8333 16.9863 12.8333 16.5001V14.6667M6.41667 11.0001H19.25M19.25 11.0001L16.5 8.25008M19.25 11.0001L16.5 13.7501",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutV2);
export default __webpack_public_path__ + "static/media/logout_v2.d6cc32097838b628a855d3c2d9b3ecc1.svg";
export { ForwardRef as ReactComponent };